import { SET_ERROR, SET_LIST, SET_LOADING } from '../Actions/storeObject';
import CarsStoreObject from '../Entities/CarsStoreObject';

interface IState {
    list: CarsStoreObject[],
    error: string | null;
    currentPage: number;
    pages: number;
    isLoading: boolean;
};

const defaultState = {
    list: [],
    error: null,
    isLoading: false,
    pages: 0,
    currentPage: 0
};

export default function newsCategory(state: IState = defaultState, action: any) {
    switch (action.type) {
        case SET_LIST:
            return {
                ...state,
                list: action.data,
                pages: action.pages,
                currentPage: action.currentPage,
                isLoading: false
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        default:
            return state;
    }
}
